import { memo } from "react";
import Skeleton from "react-loading-skeleton";

// Banners
import banquet from "../../assets/banners/banquet.jpg";
import hotel from "../../assets/banners/hotel.jpg";
import lawn from "../../assets/banners/lawn.jpg";
import phototography from "../../assets/banners/photography.jpg";
import weddingdj from "../../assets/banners/weddingdj.jpg";
import pandit from "../../assets/banners/pandit.jpg";
import anchor from "../../assets/banners/anchor.jpg";
import livemusic from "../../assets/banners/livemusic.jpg";
import brassband from "../../assets/banners/brassband.jpg";
import magician from "../../assets/banners/magician.jpg";
import planner from "../../assets/banners/plannet.jpg";
import catering from "../../assets/banners/catering.jpg";
import decorator from "../../assets/banners/decorator.jpg";
import choreographar from "../../assets/banners/choreographar.jpg";
import artist from "../../assets/banners/artist.jpg";
import makeup from "../../assets/banners/makeup.jpg";
import mehndi from "../../assets/banners/mehndi.jpg";
import bridalwear from "../../assets/banners/briedal.jpg";
import groomwear from "../../assets/banners/groom.jpg";
import clothingRendal from "../../assets/banners/clothing.jpg";
import hillplaces from "../../assets/banners/hill.jpg";
import beachplaces from "../../assets/banners/beach.jpg";
import historical from "../../assets/banners/historical.jpg";
import international from "../../assets/banners/international.jpg";
import sweets from "../../assets/banners/sweets.jpg";
import jewellery from "../../assets/banners/jewellery.jpg";
import accessories from "../../assets/banners/accessories.jpg";
import gifts from "../../assets/banners/gifts.jpg";
import invitations from "../../assets/banners/invitations.jpg";
import florist from "../../assets/banners/florist.jpg";
import car from "../../assets/banners/car.jpg";
import bus from "../../assets/banners/bus rental.jpg";
import tour from "../../assets/banners/tour.jpg";
import airline from "../../assets/banners/airline.jpg";
import vintage from "../../assets/banners/vintage.jpg";
import cakeshop from "../../assets/banners/cake.jpg";
import shopping from "../../assets/banners/shopping.jpg";
import clubbing from "../../assets/banners/BIRTHDAY CLUBBING PARTIES.jpg";
import smallParties from "../../assets/banners/resort.jpeg";
import corporate from "../../assets/banners/corporate.png";
import government from "../../assets/banners/government.png";
import safa from "../../assets/banners/safa.png";
import entryTheme from "../../assets/banners/entry-theme.png";
import birthday from "../../assets/banners/birthday.png";
import temple from "../../assets/banners/temple.jpg";
import palace from "../../assets/banners/palace.jpg";


const BannerDeciderContainer = ({ subCatId }) => {

  return (
    <img
      src="https://img.freepik.com/free-vector/handmade-vintage-greeting-card-with-daisy-rose-flower_21799-9073.jpg?semt=ais_hybrid&w=740&q=80"
      alt="event planet"
      loading="lazy"
      style={{ width: "100%", height: "200px" }}
    />
  );
};

export default memo(BannerDeciderContainer);
